// src/pages/GKNews.js
import React, { useState } from "react";

const NEWS_DATA = [
  {
    id: 1,
    title: "RBI Keeps Repo Rate Unchanged at 6.5%",
    summary: "The Monetary Policy Committee (MPC) of the Reserve Bank of India (RBI) decided to maintain the policy repo rate at 6.5% for the seventh consecutive time, focusing on withdrawal of accommodation.",
    date: "2026-04-12",
    category: "Banking & Economy",
    fullUrl: "https://rbi.org.in"
  },
  {
    id: 2,
    title: "India's GDP Growth Estimated at 7.6% for FY24",
    summary: "National Statistical Office (NSO) revised the GDP growth estimates, showing robust performance in manufacturing and construction sectors.",
    date: "2026-04-11",
    category: "Banking & Economy",
    fullUrl: "https://mospi.gov.in"
  },
  {
    id: 3,
    title: "Amitabh Kant's New Book 'Made in India' Launched",
    summary: "The book chronicles India's journey towards becoming a global manufacturing hub and the impact of 'Make in India' initiative.",
    date: "2026-04-10",
    category: "Appointments & Books",
    fullUrl: "https://pib.gov.in"
  },
  {
    id: 4,
    title: "Sundergarh's P.V. Sindhu Wins Swiss Open Title",
    summary: "Double Olympic medalist P.V. Sindhu clinched her first title of the season with a dominant win in the finals.",
    date: "2026-04-09",
    category: "Sports",
    fullUrl: "https://sportstar.thehindu.com"
  },
  {
    id: 5,
    title: "ISRO Successfully Launches 'XPoSat' Satellite",
    summary: "X-ray Polarimeter Satellite (XPoSat) will study the polarization of cosmic X-rays from astronomical sources such as black holes.",
    date: "2026-04-08",
    category: "Science & Tech",
    fullUrl: "https://isro.gov.in"
  },
  {
    id: 6,
    title: "G7 Summit 2026 to be Hosted in Italy",
    summary: "World leaders will gather to discuss global security, artificial intelligence, and climate transition strategies.",
    date: "2026-04-07",
    category: "International",
    fullUrl: "https://g7italy.it"
  }
];

const CATEGORIES = ["All", "Banking & Economy", "Science & Tech", "Sports", "Appointments & Books", "International"];

export default function GKNews() {
  const [filter, setFilter] = useState("All");
  const [search, setSearch] = useState("");
  const [copiedId, setCopiedId] = useState(null);

  const filteredNews = NEWS_DATA.filter(n => {
    const matchesFilter = filter === "All" || n.category === filter;
    const matchesSearch = n.title.toLowerCase().includes(search.toLowerCase()) || 
                          n.summary.toLowerCase().includes(search.toLowerCase());
    return matchesFilter && matchesSearch;
  });

  const saveToNotepad = (news) => {
    const existing = localStorage.getItem("exam_notes") || "";
    const newEntry = `\n---\n📌 ${news.title}\n📅 ${news.date}\n${news.summary}\n`;
    localStorage.setItem("exam_notes", existing + newEntry);
    
    // Trigger feedback
    setCopiedId(news.id);
    setTimeout(() => setCopiedId(null), 2000);
  };

  return (
    <div>
      <h1 className="page-title">Daily GK & News</h1>
      <p className="page-sub">Daily dose of current affairs and general knowledge for competitive exams</p>

      {/* Toolbar */}
      <div className="card" style={{ marginBottom: 20, padding: 15 }}>
        <div style={{ display: "flex", gap: 12, flexWrap: "wrap", alignItems: "center" }}>
          <input 
            type="text" 
            placeholder="Search news or topics..." 
            className="form-input" 
            style={{ flex: 1, minWidth: 200 }}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <div className="filter-row" style={{ marginBottom: 0 }}>
            {CATEGORIES.map(c => (
              <button 
                key={c} 
                className={`filter-btn ${filter === c ? "active" : ""}`}
                onClick={() => setFilter(c)}
              >
                {c}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* News Feed */}
      <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
        {filteredNews.length === 0 ? (
          <div className="card" style={{ textAlign: "center", padding: 40 }}>
            <p style={{ color: "var(--text-muted)" }}>No news items found matching your search.</p>
          </div>
        ) : (
          filteredNews.map(news => (
            <div key={news.id} className="card" style={{ padding: 20 }}>
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 10 }}>
                <span className="tag tag-medium">{news.category}</span>
                <span style={{ fontSize: 12, color: "var(--text-muted)", fontWeight: 600 }}>{new Date(news.date).toLocaleDateString("en-IN", { day: "numeric", month: "long" })}</span>
              </div>

              <h3 style={{ fontSize: 17, fontWeight: 700, marginBottom: 8, color: "var(--text-primary)" }}>{news.title}</h3>
              <p style={{ fontSize: 14, color: "var(--text-secondary)", lineHeight: 1.6, marginBottom: 16 }}>{news.summary}</p>

              <div style={{ display: "flex", gap: 10 }}>
                <a 
                  href={news.fullUrl} 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="btn btn-sm"
                  style={{ borderRadius: 8 }}
                >
                  Read More ↗
                </a>
                <button 
                  className="btn btn-sm btn-blue" 
                  style={{ borderRadius: 8, minWidth: 100 }}
                  onClick={() => saveToNotepad(news)}
                >
                  {copiedId === news.id ? "✅ Saved!" : "📝 Save to Notepad"}
                </button>
              </div>
            </div>
          ))
        )}
      </div>

      <div style={{ marginTop: 30, textAlign: "center", color: "var(--text-muted)", fontSize: 13 }}>
        You've reached the end for today. Check back tomorrow for more updates!
      </div>
    </div>
  );
}
